import { configureStore } from '@reduxjs/toolkit';
import onBoardingReducer from './onBoarding/onBoarding';

const store = configureStore({
  reducer: {
    onBoarding: onBoardingReducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
